export enum SymptomHostTypes {
    TREATMENT = 'treatment',
    DRUG = 'drug'
}
